import type { MouseEvent } from 'react';

interface MobileActionButtonProps {
  /** Receives the click event so callers that need the button's position (e.g. a
   *  positioned dropdown) can read `e.currentTarget.getBoundingClientRect()`.
   *  A plain `() => void` handler stays assignable. */
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  title: string;
}

/**
 * Shared mobile-only action button — grey rectangle, 44x44.
 * Hidden on desktop (>767px), visible on mobile via CSS.
 */
export function MobileActionButton({ onClick, title }: MobileActionButtonProps) {
  return (
    <button
      type="button"
      className="mobile-action-button"
      onClick={onClick}
      title={title}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
    </button>
  );
}
